export const memberQueryKeys = {
    all: (scenarioId: string) => ['member', scenarioId],
} as const;
